import { Box, BoxProps } from '@mui/material';

export const VectorLayers = (props: BoxProps): JSX.Element => {
  return (
    <Box {...props}>
      <svg
        width="76"
        height="80"
        viewBox="0 0 76 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.0311282 76.923C-0.16321 78.0103 0.560711 79.0494 1.64805 79.2437C2.73539 79.438 3.77439 78.7141 3.96873 77.6268L1.99993 77.2749L0.0311282 76.923ZM75.714 12.3054C76.2831 11.3587 75.9771 10.1299 75.0304 9.56078L59.6037 0.286337C58.657 -0.282791 57.4282 0.0232663 56.8591 0.969927C56.29 1.91659 56.596 3.14538 57.5427 3.7145L71.2554 11.9585L63.0114 25.6711C62.4423 26.6178 62.7483 27.8466 63.695 28.4157C64.6417 28.9848 65.8704 28.6788 66.4396 27.7321L75.714 12.3054ZM1.99993 77.2749L3.96873 77.6268C6.82974 61.6192 12.7615 48.5075 23.7013 37.9303C34.6724 27.3228 50.8466 19.1027 74.4833 13.2156L73.9999 11.2749L73.5166 9.33416C49.4851 15.3196 32.575 23.7868 20.9209 35.0546C9.23545 46.3528 3.00125 60.3049 0.0311282 76.923L1.99993 77.2749Z"
          fill="#FBB92D"
        />
      </svg>
    </Box>
  );
};
